export default __webpack_public_path__ + "static/media/enbek-mansap-logo.10bc0ff8.svg";